import { Injectable } from '@angular/core';
import { Errors, ErrorType } from 'src/app/shared/enums/error';
import { QuestionariType } from '../model/questionnaire-response';
import { IUser } from 'src/app/core/models/user.model';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { QuestionnairesService } from './questionnaires.service';

@Injectable({
  providedIn: 'root'
})
export class PhysicalExamService {
  private patientSelectedId: string | null = null;
  private physicalExamSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
  ) {
    this.physicalExamSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getPhysicalExam() {
    return this.physicalExamSubject.asObservable();
  }

  async loadPhysicalExam(patientId: string, user: IUser): Promise<void> {

    this.physicalExamSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'physicalExam', patientId, user.practitionerId)
      .then(result => {
        if (result) {
          this.physicalExamSubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            today: { ...result?.today }
          });
        }
      });
  }

  async savePhysicalExam({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadPhysicalExam(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de exame físico.',
        error
      );
    }
  }

  async updatePhysicalExam({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadPhysicalExam(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de exame físico.',
        error
      );
    }
  }
}
